import { render, staticRenderFns } from "./SGPFormDataRangeComponent.vue?vue&type=template&id=a2a72bd4&scoped=true"
import script from "./SGPFormDataRangeComponent.vue?vue&type=script&lang=js"
export * from "./SGPFormDataRangeComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPFormDataRangeComponent.vue?vue&type=style&index=0&id=a2a72bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a72bd4",
  null
  
)

export default component.exports